// Module
var code = `<div class="properties-header">
  <h3>{{referenceClassName}}<span>{{sectionTitle}}</span></h3>
</div>

<div class="properties-body">
  <div class="properties-method-head">
    <p class="header-content properties-header-method-name">
      {{methodHeadName}} (
    </p>
    <p class="header-content properties-header-method-params check-for-empty">
      {{methodHeadParams}}
    </p>
    <p class="header-content properties-header-method-trailing-parens">
      ){{methodHeadTrailingParam}}
    </p>
  </div>

  <table class="properties">
    <thead>
      <tr>
        <th><p>Parameter</p></th>
        <th><p>Default</p></th>
        <th><p>Type(s)</p></th>
        <th><p>Description</p></th>
      </tr>
    </thead>

    <tbody class="properties check-for-empty">
      {{#properties}}
      <tr class="property-row {{rowClass}} is-required-{{propertyRequired}}">
        <td class="td-prop td-prop-name">
          <p>{{propertyName}}</p>
        </td>
        <td class="td-prop td-prop-default">
          <p>{{propertyDefault}}</p>
        </td>
        <td class="td-prop td-prop-type">
          <p>{{propertyValue}}</p>
        </td>
        <td class="td-prop td-prop-desc">
          <p>{{propertyDesc}}</p>
        </td>
      </tr>
      {{/properties}}
    </tbody>
  </table>

  <!--    <pre class="properties-return reveal-{{returns.0.revealReturn}}">
        <code class="hljs language-javascript">
  {
{{#returns}}
   // {{propertyDesc}}
   return {{propertyName}}
{{/returns}}
  }
        </code>

    </pre>
    -->

    <table class="properties-return-table">
        <thead>
        <tr>
            <th><p>Return Parameter(s)</p></th>
            <th><p>Default</p></th>
            <th><p>Type(s)</p></th>
            <th><p>Description</p></th>
        </tr>
        </thead>

        <tbody class="properties-return-tbody check-for-empty">
        {{#propertiesReturn}}
        <tr class="property-row {{rowClass}} is-required-{{propertyRequired}}">
            <td class="td-prop td-prop-name">
                <p>{{propertyName}}</p>
            </td>
            <td class="td-prop td-prop-default">
                <p>{{propertyDefault}}</p>
            </td>
            <td class="td-prop td-prop-type">
                <p>{{propertyValue}}</p>
            </td>
            <td class="td-prop td-prop-desc">
                <p>{{propertyDesc}}</p>
            </td>
        </tr>
        {{/propertiesReturn}}
        </tbody>
    </table>

    <!-- PROPERTIES RETURN START -->
  <div class="properties-return reveal-{{returns.0.revealReturn}}">
    <p class="return-content return-open-bracket">{</p>

    <p class="return-content return-statement">
      <!-- <b>return</b>-->
      {{#returns}}
      <span class="{{propertyClass}}"
        >{{propertyName}} <i class="check-for-empty">{{propertyDesc}}</i></span
      >
      {{/returns}}
    </p>

    <p class="return-content return-close-bracket">}</p>
  </div>


    <!-- PROPERTIES RETURN END -->
</div>





<div class="properties-description">
  <h4>{{info.title}}</h4>

  {{#info.body}}
  <p>{{.*}}</p>

  {{/info.body}}
</div>
`;
// Exports
module.exports = code;